module.exports = __webpack_public_path__ + "media/images/flags/16/East-Timor-36eaeb9f6c5adb206b50378eaf7f879c.png";